var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "npb-voice-flash-call-overlay" }, [
    _c("div", { staticClass: "npb-voice-flash-call-modal" }, [
      _c(
        "button",
        {
          staticClass: "npb-voice-flash-call-close-btn",
          attrs: { type: "button" },
          on: { click: _vm.closeCallModal },
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _vm.isSMS
        ? _c("div", {
            staticClass: "npb-voice-flash-call-image__sms with-modal",
          })
        : _vm.isFlashCall
        ? _c("div", {
            staticClass: "npb-voice-flash-call-image__flash with-modal",
          })
        : _vm.isVoiceCall
        ? _c("div", {
            staticClass: "npb-voice-flash-call-image__voice with-modal",
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "npb-voice-flash-call-content" }, [
        _vm.isSMS
          ? _c("div", [
              _c(
                "div",
                { staticClass: "npb-voice-flash-call-content__title" },
                [
                  _c("i18n", {
                    attrs: { val: "second_step_modal_sms_info_title" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "npb-voice-flash-call-content__text" },
                [
                  _c("i18n", {
                    attrs: { val: "second_step_modal_sms_info_text" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "npb-voice-flash-call-button",
                  on: {
                    "~click": function ($event) {
                      return _vm.sendPhoneModalRequest.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block btn-sm npb-main-button",
                      attrs: { type: "button" },
                    },
                    [
                      _c("i18n", {
                        attrs: { val: "second_step_modal_sms_button_text" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ])
          : _vm.isFlashCall
          ? _c("div", [
              _c(
                "div",
                { staticClass: "npb-voice-flash-call-content__title" },
                [
                  _c("i18n", {
                    attrs: { val: "second_step_modal_flash_call_info_title" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "npb-voice-flash-call-content__text" }, [
                _c(
                  "span",
                  [
                    _c("i18n", {
                      attrs: {
                        val: "second_step_modal_flash_call_info_text_example",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "npb-voice-flash-call_content__text-phone npb-nowrap",
                  },
                  [
                    _c(
                      "span",
                      [
                        _c("i18n", {
                          attrs: {
                            val: "second_step_modal_flash_call_info_text_phone",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "npb-voice-flash-call-content__text-circled",
                      },
                      [_vm._v("4359")]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "npb-voice-flash-call-content__text" },
                [_c("i18n", { attrs: { val: "flash_call_info_text_extend" } })],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "npb-voice-flash-call-button" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-block btn-sm npb-main-button",
                    attrs: { type: "button" },
                    on: {
                      "~click": function ($event) {
                        return _vm.sendPhoneModalRequest.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i18n", {
                      attrs: {
                        val: "second_step_modal_flash_call_button_text",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ])
          : _vm.isVoiceCall
          ? _c("div", [
              _c(
                "div",
                { staticClass: "npb-voice-flash-call-content__title" },
                [
                  _c("i18n", {
                    attrs: { val: "second_step_modal_voice_call_info_title" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "npb-voice-flash-call-content__text" },
                [
                  _c("i18n", {
                    attrs: { val: "second_step_modal_voice_call_info_text" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "npb-voice-flash-call-button",
                  on: {
                    "~click": function ($event) {
                      return _vm.sendPhoneModalRequest.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block btn-sm npb-main-button",
                      attrs: { type: "button" },
                    },
                    [
                      _c("i18n", {
                        attrs: {
                          val: "second_step_modal_voice_call_button_text",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }